import React, { ElementType, FC } from 'react';
import { ColorScheme } from '../colorScheme';
import {
  StyledH1,
  StyledH2,
  StyledH3,
  StyledH4,
  StyledH5,
  StyledH6,
  StyledH7,
  StyledH8,
  StyledH9,
  StyledManchet,
  StyledContent,
  StyledContentSmall,
  StyledContentSmallLink,
  StyledDate,
  StyledContentLink,
  TypographyAlign,
  StyledTableLabel
} from '../newGlobalFonts';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'h7'
  | 'h8'
  | 'h9'
  | 'manchet'
  | 'content'
  | 'contentSmall'
  | 'contentSmallLink'
  | 'contentLink'
  | 'date'
  | 'tableLabel';

export type { TypographyAlign };

export interface TypographyProps {
  variant: TypographyVariant;
  as: ElementType;
  color?: ColorScheme;
  align?: TypographyAlign;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const variantComponents = {
  h1: StyledH1,
  h2: StyledH2,
  h3: StyledH3,
  h4: StyledH4,
  h5: StyledH5,
  h6: StyledH6,
  h7: StyledH7,
  h8: StyledH8,
  h9: StyledH9,
  manchet: StyledManchet,
  content: StyledContent,
  contentLink: StyledContentLink,
  contentSmall: StyledContentSmall,
  contentSmallLink: StyledContentSmallLink,
  date: StyledDate,
  tableLabel: StyledTableLabel
};

export const Typography: FC<TypographyProps> = ({
  variant,
  as,
  color = ColorScheme.DarkGreen,
  align = 'center',
  children,
  className,
  style,
  onClick
}) => {
  const StyledComponent = variantComponents[variant];

  return (
    <StyledComponent
      as={as}
      $color={color}
      $align={align}
      className={className}
      style={style}
      onClick={onClick}
    >
      {children}
    </StyledComponent>
  );
};

export default Typography;
